import s from './vacation-button.module.scss'
import classNames from 'classnames'
import { IconBeach, IconEdit } from '@tabler/icons-react'
import useMedia from 'use-media'
import { useProfile } from '@shared/api/useProfile'
import { useVacationModal } from '../../model/use-vacation-modal'

export const VacationButton = () => {
	const { data: profile } = useProfile()
	const { open } = useVacationModal()
	const isTablet = useMedia({ maxWidth: '1312px' })
	const vacationEnabled = !!profile?.vacation_enabled

	return (
		<button type='button' className={s.wrapper} onClick={() => open()}>
			<span className={s.info}>
				<IconBeach size={18} className={classNames(s.icon, vacationEnabled && s.iconActive)} />
				<span className={s.label}>Отпуск</span>
				<span className={classNames(s.status, vacationEnabled && s.statusActive)}>
					{vacationEnabled ? 'включён' : 'выключен'}
				</span>
			</span>
			<span className={s.edit}>
				{isTablet ? <IconEdit /> : 'Изменить'}
			</span>
		</button>
	)
}
